import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';
import SiteNav from './seo/SiteNav.jsx';

const {FiExternalLink} = FiIcons;

const AboutSection = () => (
  <section
    aria-labelledby="about-heading"
    className="rounded-2xl border border-white/[0.1] bg-white/[0.04] p-4"
  >
    <h2 id="about-heading" className="text-sm font-black text-white">
      關於羽球計分板
    </h2>
    <p className="mt-2 text-xs font-bold leading-relaxed text-white/50">
      本工具為球員、教練、球會及小型比賽提供免費的瀏覽器羽毛球計分功能。
      比賽及設定資料保存在目前瀏覽器。
    </p>

    <h3 className="mt-4 text-xs font-black text-white/80">
      查看完整教學和資料
    </h3>
    <div className="mt-3">
      <SiteNav compact />
    </div>

    <h3 className="mt-4 text-xs font-black text-white/80">
      聯絡網站維護者
    </h3>
    <a
      href="https://homy.hk/"
      target="_blank"
      rel="noopener noreferrer"
      className="mt-3 flex items-center justify-center gap-1.5 rounded-xl border border-white/10 bg-white/[0.05] px-3 py-2 text-xs font-black text-white/60 transition-all hover:border-indigo-400/30 hover:bg-white/[0.09] hover:text-white"
    >
      <SafeIcon icon={FiExternalLink} aria-hidden="true" />
      前往 Homy 網站
    </a>
  </section>
);

export default AboutSection;